<template>
    <div class="pro_container">
        <global-tag>
            <span slot="title">申请</span>
            <div class="search" slot="search">
                <el-form label-width="100px">
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="姓名：">
                                <el-input
                                    v-model.trim="username"
                                    placeholder="请输入姓名"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="联系方式：">
                                <el-input
                                    v-model.trim="phone"
                                    placeholder="请输入联系方式"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="身份证号：">
                                <el-input
                                    v-model.trim="idCard"
                                    placeholder="请输入身份证号"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" :offset="1">
                            <el-button
                                type="primary"
                                class="searchBtns"
                                @click="search"
                                >搜索</el-button
                            >
                        </el-col>
                        <el-col :span="4">
                            <el-button
                                type="info"
                                class="resetReach"
                                @click="reset"
                                >重置</el-button
                            >
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </global-tag>
        <div class="table_title">
            <div
                class="screen_container"
                style="width: 100%; margin-top: 24px; text-align: right"
            >
                <el-button-group>
                    <el-button
                        type="primary"
                        class="dropRests"
                        icon="el-icon-refresh"
                        @click="Reset1"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                    <el-dropdown
                        class="dropdown1"
                        trigger="click"
                        :hide-on-click="false"
                    >
                        <span class="el-dropdown-link">
                            <i
                                class="el-icon-s-grid el-icon--right"
                                style="color: #fff"
                            ></i>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu
                            slot="dropdown"
                            class="table_checkbox"
                        >
                            <el-dropdown-item>
                                <el-checkbox-group
                                    v-model="tableChekbox"
                                    @change="tableChekboxChange"
                                >
                                    <el-checkbox label="序号"></el-checkbox>
                                    <br />
                                    <el-checkbox label="姓名"></el-checkbox>
                                    <br />
                                    <el-checkbox label="性别"></el-checkbox>
                                    <br />
                                    <el-checkbox label="联系方式"></el-checkbox>
                                    <br />
                                    <el-checkbox label="身份证号"></el-checkbox>
                                    <br />
                                    <el-checkbox label="年龄"></el-checkbox>
                                    <br />
                                    <el-checkbox label="详细地址"></el-checkbox>
                                    <br />
                                    <el-checkbox label="来源"></el-checkbox>
                                    <br />
                                    <el-checkbox label="创建人"></el-checkbox>
                                    <br />
                                    <el-checkbox label="状态"></el-checkbox>
                                    <br />
                                    <el-checkbox label="操作"></el-checkbox>
                                </el-checkbox-group>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!-- tableb表格 -->
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    width="60px"
                    align="center"
                    label="序号"
                    type="index"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item === '序号'
                        ) !== -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    min-width="100px"
                    label="姓名"
                    prop="customerName"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item === '姓名'
                        ) !== -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    min-width="70px"
                    label="性别"
                    prop="gender"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item === '性别'
                        ) !== -1
                    "
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.gender == 0 ? "男" : "女" }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    min-width="120px"
                    label="联系方式"
                    prop="phone"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item === '联系方式'
                        ) !== -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    min-width="150px"
                    label="身份证号"
                    prop="idCard"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item === '身份证号'
                        ) !== -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    min-width="70px"
                    label="年龄"
                    prop="age"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item === '年龄'
                        ) !== -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    min-width="200px"
                    label="详细地址"
                    prop="address"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item === '详细地址'
                        ) !== -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="createPersonName"
                    min-width="60px"
                    label="创建人"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    align="center"
                    min-width="80px"
                    label="状态"
                    prop="examine"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item === '状态'
                        ) !== -1
                    "
                >
                    <template slot-scope="scope">
                        <span>{{
                            scope.row.examine == 1
                                ? "审核通过"
                                : scope.row.examine == 2
                                ? "审核未通过"
                                : "待审核"
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    min-width="150px"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item === '操作'
                        ) !== -1
                    "
                >
                    <template slot-scope="scope">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="查看"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/detail.png"
                                style="cursor: pointer"
                                @click="handleTableForm('详情', scope.row)"
                            />
                        </el-tooltip>
                        <!-- <el-tooltip effect="dark" content="编辑" placement="top-start">
              <img src="../assets/img/table_edit.png" @click="handleTableForm('编辑',scope.row)" style="margin-left: 12px; cursor: pointer"/>
            </el-tooltip> -->
                        <el-tooltip
                            effect="dark"
                            content="审核"
                            placement="top-start"
                            v-if="scope.row.examine != 2"
                        >
                            <img
                                alt
                                src="../assets/img/examine.png"
                                @click="handleTableForm('审核', scope.row)"
                                style="
                                    width: 18px;
                                    margin-left: 12px;
                                    cursor: pointer;
                                "
                            />
                        </el-tooltip>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="删除"
                            placement="top-start"
                        >
                            <img
                                alt
                                src="../assets/img/table_delete.png"
                                @click="handleDelete(scope.row)"
                                style="margin-left: 12px; cursor: pointer"
                            />
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                :page-size="pageSize"
                :total="total"
                :current-page.sync="pageNo"
                @size-change="handletableDataSize"
                @current-change="handleTableDataChange"
            ></el-pagination>
        </div>
        <!-- tbale 新增删除修改弹窗 -->
        <el-dialog
            :title="dialogVisibleTitle"
            :visible.sync="dialogVisible"
            width="60%"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    label-position="left"
                    label-width="100px"
                    :model="formData"
                    :disabled="dialogVisibleTitle === '详情'"
                >
                    <el-row>
                        <el-col :span="24" class="dialog_form">
                            <el-row
                                style="
                                    display: flex;
                                    align-items: center;
                                    margin-bottom: 20px;
                                "
                            >
                                <el-col :span="18">
                                    <el-row>
                                        <el-col :span="11">
                                            <el-form-item label="姓名：">
                                                <el-input
                                                    v-model.trim="
                                                        formData.customerName
                                                    "
                                                    :disabled="
                                                        dialogVisibleTitle ===
                                                        '审核'
                                                    "
                                                ></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="11" :offset="2">
                                            <el-form-item label="性别：">
                                                <el-radio-group
                                                    v-model="formData.gender"
                                                    :disabled="
                                                        dialogVisibleTitle ===
                                                        '审核'
                                                    "
                                                >
                                                    <el-radio label="0"
                                                        >男</el-radio
                                                    >
                                                    <el-radio label="1"
                                                        >女</el-radio
                                                    >
                                                </el-radio-group>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-form-item label="联系方式：">
                                                <el-input
                                                    v-model.trim="
                                                        formData.phone
                                                    "
                                                    :disabled="
                                                        dialogVisibleTitle ===
                                                        '审核'
                                                    "
                                                ></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="11" :offset="2">
                                            <el-form-item label="身份证号：">
                                                <el-input
                                                    v-model.trim="
                                                        formData.idCard
                                                    "
                                                    :disabled="
                                                        dialogVisibleTitle ===
                                                        '审核'
                                                    "
                                                ></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-form-item label="年龄：">
                                                <el-input
                                                    v-model.trim="formData.age"
                                                    :disabled="
                                                        dialogVisibleTitle ===
                                                        '审核'
                                                    "
                                                ></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="11" :offset="2">
                                            <el-form-item label="老人类别：">
                                                <el-select
                                                    v-model="
                                                        formData.elderlyBelongCategory
                                                    "
                                                    style="width: 100%"
                                                    :disabled="
                                                        dialogVisibleTitle ===
                                                        '审核'
                                                    "
                                                    placeholder="请选择老人类别"
                                                >
                                                    <el-option
                                                        v-for="(
                                                            item, index
                                                        ) in oldtypeLits"
                                                        :key="index"
                                                        :label="item.dictLabel"
                                                        :value="item.dictCode"
                                                    ></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col
                                    :span="6"
                                    style="
                                        display: flex;
                                        flex-direction: column;
                                        align-items: flex-end;
                                    "
                                >
                                    <el-upload
                                        :action="baseUrl"
                                        :show-file-list="false"
                                        :on-success="
                                            (file, fileList) => {
                                                handleAvatarSuccess(
                                                    file,
                                                    fileList,
                                                    'add'
                                                )
                                            }
                                        "
                                        :before-upload="beforeAvatarUpload"
                                        accept=".jpg,.png"
                                        :disabled="true"
                                    >
                                        <div
                                            class="avatar"
                                            v-if="formData.photo"
                                        >
                                            <img alt :src="formData.photo" />
                                        </div>
                                        <div v-else>
                                            <div
                                                class="avatar"
                                                v-if="
                                                    dialogVisibleTitle ===
                                                    '查看'
                                                "
                                            >
                                                <img
                                                    alt
                                                    src="../assets/img/user.png"
                                                />
                                            </div>
                                            <i
                                                class="
                                                    el-icon-plus
                                                    avatar_uploader
                                                    avatar-uploader-icon
                                                "
                                                v-else
                                            ></i>
                                        </div>
                                    </el-upload>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-form-item label="居住地地址：">
                        <el-row>
                            <el-col :span="4">
                                <el-form-item>
                                    <el-select
                                        v-model="formData.provinceId"
                                        placeholder="请选择省"
                                        @change="handleProvince"
                                        :disabled="
                                            dialogVisibleTitle === '审核'
                                        "
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="(
                                                item, index
                                            ) in provinceList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    v-model="formData.cityId"
                                    placeholder="请选择市"
                                    @change="handleCity"
                                    :disabled="dialogVisibleTitle === '审核'"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in cityList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.adcode"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    v-model="formData.areaId"
                                    placeholder="请选择区"
                                    :disabled="dialogVisibleTitle === '审核'"
                                    @change="handleArea"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in areaList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.adcode"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    v-model="formData.streetId"
                                    placeholder="请选择街道"
                                    @change="streetChange"
                                    :disabled="dialogVisibleTitle === '审核'"
                                >
                                    <el-option
                                        v-for="(item, index) in streetList"
                                        :key="index"
                                        :label="item.addName"
                                        :value="item.addCode"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    v-model="formData.communityId"
                                    placeholder="请选择社区"
                                    :disabled="dialogVisibleTitle === '审核'"
                                >
                                    <el-option
                                        v-for="item in communityList"
                                        :key="item.id"
                                        :label="item.address"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-input
                            v-model.trim="formData.address"
                            id="tipinput"
                            class="el-input__inner"
                            :class="
                                dialogVisibleTitle === '详情'
                                    ? 'is-disabled'
                                    : ''
                            "
                            :disabled="
                                dialogVisibleTitle === '详情' ||
                                dialogVisibleTitle === '审核'
                            "
                            @change="getMap"
                            style="margin-top: 12px; margin-bottom: 12px"
                            placeholder="请输入关键字"
                            autocomplete="off"
                        ></el-input>
                        <!--            <el-input v-model.trim="formData.address" :disabled="true" style="margin-top: 12px;margin-bottom: 12px;" placeholder="请在地图的边界内点击选择详细信息" ></el-input>-->

                        <div class="map_container">
                            <!-- <div class="map_left">
                <p v-for="(item, index) in streetList" :key="index">{{ item.name }}</p>
              </div> -->
                            <div
                                class="map_right"
                                id="container"
                                style="width: 100%; height: 300px"
                            ></div>
                        </div>
                    </el-form-item>
                    <!-- <el-form-item label="居住地址：">
            <el-row>
              <el-col :span="5">
                <el-form-item>
                  <el-select
                    v-model="formData.provinceId"
                    placeholder="请选择省"
                    @change="handleProvince"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in provinceList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5" :offset="1">
                <el-select
                  v-model="formData.cityId"
                  placeholder="请选择市"
                  @change="handleCity"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in cityList"
                    :key="index"
                    :label="item.name"
                    :value="item.adcode"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="5" :offset="1">
                <el-select
                  v-model="formData.quId"
                  placeholder="请选择区"
                  @change="handleArea"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in areaList"
                    :key="index"
                    :label="item.name"
                    :value="item.adcode + index"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="6" :offset="1">
                <el-select v-model="formData.streetId" placeholder="请选择街道">
                  <el-option
                    v-for="(item, index) in streetList"
                    :key="index"
                    :label="item.name"
                    :value="item.adcode + index">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-input v-model="formData.address" style="margin-top: 12px;" placeholder="请输入详细地址"></el-input>
          </el-form-item> -->
                    <!-- <el-form-item label="单位名称：">
            <el-input v-model="formData.companyNmae"></el-input>
          </el-form-item>
          <el-form-item label="责任人：">
            <el-input v-model="formData.dutyPerson"></el-input>
          </el-form-item> -->
                    <template
                        v-if="
                            dialogVisibleTitle === '审核' ||
                            (dialogVisibleTitle === '详情' &&
                                formData.status != 0)
                        "
                    >
                        <el-divider></el-divider>
                        <el-form-item label="状态：">
                            <el-radio-group v-model="formData.examine">
                                <el-radio label="1">审核通过</el-radio>
                                <el-radio label="2">审核不通过</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <!-- <el-form-item label="原因：">
                <el-input type="textarea" v-model.trim="formData.reason" :rows="5"></el-input>
              </el-form-item> -->
                    </template>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click="handleSubmit"
                    v-show="dialogVisibleTitle != '详情'"
                    >确 定</el-button
                >
                <el-button @click="dialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import vueQr from "vue-qr"
import baseURL from "@/api/baseURL"
import globalTag from "../components/globalTag"
import { chekCode } from "../util"
import { Row } from "element-ui"

export default {
    name: "proManage",
    data() {
        return {
            imageUrl: "", //图片地址
            username: "", //姓名
            phone: "", //联系方式
            idCard: "", //身份证号
            pageSize: 10,
            pageNo: 1,
            total: 0,
            oldtypeLits: [],
            tempTableChekbox: [
                "序号",
                "姓名",
                "性别",
                "联系方式",
                "身份证号",
                "年龄",
                "详细地址",
                "来源",
                "创建人",
                "状态",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "姓名",
                "性别",
                "联系方式",
                "身份证号",
                "年龄",
                "详细地址",
                "来源",
                "创建人",
                "状态",
                "操作",
            ],
            tableData: [
                // tabble数据
            ],
            dialogVisible: false, //table表单弹窗
            dialogVisibleTitle: "", //table表单弹窗title
            formData: {
                //table表单
                customerName: "", //姓名
                gender: "", //性别
                phone: "", //联系方式
                idCard: "", //身份证号
                age: "", //年龄
                elderlyBelongCategory: "", //老人类型
                provinceId: "", //省
                cityId: "", //市
                areaId: "", //区
                streetId: "", //街道
                communityId: "", //社区
                address: "", //居住地址
                photo: "", //图片
                reason: "", //原因
                examine: "", //状态
                source: "", //来源
                longitude: "", //经度
                latitude: "", //纬度
            },
            province: "", //省
            provinceList: [],
            cityList: [],
            areaList: [],
            streetList: [],
            communityList: [
                //社区列表
            ],
            myMap: null,
            polygons: [],
            polygon: [],
            marker: null,
            isMap: true,
        }
    },
    components: {
        globalTag,
        vueQr,
    },
    inject: ["reload"], //注入
    mounted() {
        this.getElderlyInformation()
    },
    async created() {
        this.gettypeList()
        this.getProvince()
        this.baseUrl =
            baseURL + "/jjyl/controller/uploadController/info/uploadPhoto"
    },
    methods: {
        gettypeList() {
            let query = {
                pageNum: 1,
                pageSize: 999,
                dictType: "customer.type",
            }
            this.$http
                .request({
                    url: "/rbac/system/dict/data/list",
                    method: "get",
                    params: query,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.rows != null) {
                            this.oldtypeLits = res.rows
                            this.oldtypeLits.forEach((item) => {
                                item.dictCode = String(item.dictCode)
                            })
                        }
                    }
                })
        },
        getMap() {
            this.form = this.formData
            const autoOptions = {
                city: this.form.areaId,
                citylimit: true,
                input: "tipinput",
            }
            const auto = new AMap.Autocomplete(autoOptions)
            AMap.event.addListener(auto, "select", (e) => {
                const marker = new AMap.Marker({
                    icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                    position: e.poi.location,
                })
                // CLASS_NAME: "AMap.Marker"
                // 删除之前的定位点
                // const MarkerList = this.myMap.getAllOverlays().filter(item => item.CLASS_NAME === 'AMap.Marker')
                const MarkerList = this.myMap.getAllOverlays()
                this.myMap.remove(MarkerList)
                // 设置选择的坐标点
                this.myMap.add(marker)
                this.myMap.setFitView()
                this.form.address = e.poi.name
                this.form.longitude = e.poi.location.lng
                this.form.latitude = e.poi.location.lat
                //注册监听，当选中某条记录时会触发
                // placeSearch.setCity(e.poi.adcode)
                // placeSearch.search(e.poi.name) //关键字查询查询
            })
        },
        //清除搜索条件
        reset() {
            this.pageSize = 10
            this.pageNo = 1
            this.username = ""
            this.phone = ""
            this.idCard = ""
            this.getElderlyInformation()
        },
        //获取地址
        getDistrict(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    const MarkerList = self.myMap
                        .getAllOverlays()
                        .filter((item) => item.CLASS_NAME === "AMap.Marker")
                    self.myMap.remove(MarkerList)
                    self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }
                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                        if (bounds) {
                            self.myMap.remove(self.polygons)
                            self.polygons = []
                            for (let i = 0, l = bounds.length; i < l; i++) {
                                self.polygon = new AMap.Polygon({
                                    map: self.myMap,
                                    strokeWeight: 1,
                                    strokeColor: "#0091ea",
                                    fillColor: "#80d8ff",
                                    fillOpacity: 0.4,
                                    path: bounds[i],
                                })
                                self.polygons.push(self.polygon)
                                if (!params) {
                                    self.polygon.on("click", function (e) {
                                        let lnglat = e.lnglat
                                        self.myMap.add(self.marker)
                                        self.marker.setPosition(lnglat)
                                        geocoder.getAddress(
                                            lnglat,
                                            function (status, result) {
                                                if (
                                                    status === "complete" &&
                                                    result.regeocode
                                                ) {
                                                    var address =
                                                        result.regeocode
                                                            .formattedAddress
                                                    self.formData.address =
                                                        address
                                                    self.formData.longitude =
                                                        lnglat.lng
                                                    self.formData.latitude =
                                                        lnglat.lat
                                                } else {
                                                    console.error(
                                                        "根据经纬度查询地址失败"
                                                    )
                                                }
                                            }
                                        )
                                    })

                                    self.myMap.add(self.polygons)

                                    self.myMap.add(self.marker)
                                    self.marker.setPosition([
                                        result.districtList[0].center.lng,
                                        result.districtList[0].center.lat,
                                    ])
                                    self.myMap.setFitView(self.marker)
                                    self.myMap.setZoom(11)
                                    self.myMap.setFitView() //地图自适应
                                } else {
                                    if (params.longitude && params.latitude) {
                                        self.myMap.add(self.marker)
                                        self.marker.setPosition([
                                            params.longitude,
                                            params.latitude,
                                        ])
                                        self.myMap.setFitView(self.marker)
                                        self.myMap.setZoom(11)
                                    }
                                }
                            }
                        }
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        //获取省级
        async getProvince() {
            this.provinceLis = []
            this.cityList = []
            this.areaList = []
            this.streetList = []
            let province = await this.getDistrict()
            this.provinceList = province.districtList
            // console.log(this.provinceList, "this.provinceListooo")
        },
        //  省级地址选择发生改变
        async handleProvince(val) {
            this.cityList = []
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.formData.cityId = ""
            this.formData.areaId = ""
            this.formData.streetId = ""
            this.formData.communityId = ""
            this.formData.address = ""
            let city = await this.getDistrict(val)
            this.cityList = city.districtList
        },
        //市级地址发生改变
        async handleCity(val) {
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.formData.areaId = ""
            this.formData.streetId = ""
            this.formData.communityId = ""
            this.formData.address = ""
            let area = await this.getDistrict(val)
            this.areaList = area.districtList
        },
        //县区级地址发生改变
        async handleArea(val) {
            this.streetList = []
            this.communityList = []
            this.formData.streetId = ""
            this.formData.communityId = ""
            this.formData.address = ""
            // val = val.replace(/.$/, "");
            let streetList = await this.getStreetList(val)
            this.streetList = streetList
        },
        getStreetList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/addressYpe/info/findList",
                        method: "POST",
                        data: {
                            parentId: val,
                            pageNo: 1,
                            pageSize: -1,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            this.streetList = res.content.list
                            resolve(res.content.list)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {
                console.log(err)
            })
        },
        // 社区地址列表
        getCommityList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                        method: "POST",
                        data: {
                            streetId: val,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            this.shequList = res.content
                            resolve(res.content)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {
                console.log(err)
            })
        },
        //街道地址发生变化
        async streetChange(val, flag = null) {
            let communityList = await this.getCommityList(val)
            this.communityList = communityList
        },
        //审核老人信息
        handleSubmit() {
            let self = this
            if (!self.formData.customerName) {
                self.$message.error("姓名为必填项，请填写")
                return
            }
            if (!self.formData.phone) {
                self.$message.error("联系方式必填项，请填写")
                return
            }
            let validatePhone = /^1[3|4|5|6|7|8|9]\d{9}$/
            if (!validatePhone.test(self.formData.phone)) {
                self.$message.error("手机号格式错误")
                return
            }
            if (!self.formData.idCard) {
                self.$message.error("身份证号必填项，请填写")
                return
            }
            if (!chekCode(self.formData.idCard)) {
                self.$message.error("身份证号格式错误")
                return
            }
            if (!self.formData.age) {
                self.$message.error("年龄为必填项，请填写")
                return
            }
            if (
                self.formData.elderlyBelongCategory === null ||
                self.formData.elderlyBelongCategory === "" ||
                self.formData.elderlyBelongCategory === undefined
            ) {
                self.$message.error("老人类型为必填项，请选择")
                return
            }
            if (!self.formData.provinceId) {
                self.$message.error("省级地址为必填项，请选择")
                return
            }
            if (!self.formData.cityId) {
                self.$message.error("市级地址为必填项，请选择")
                return
            }
            if (!self.formData.areaId) {
                self.$message.error("区县级地址为必填项，请选择")
                return
            }
            if (!self.formData.streetId) {
                self.$message.error("街道地址为必填项，请选择")
                return
            }
            // if (self.formData.communityId === '' || self.formData.communityId === null || self.formData.communityId === undefined) {
            //   self.$message.error("社区为必填项，请选择,如无对应社区，请地址管理配置");
            //   return;
            // }
            if (!self.formData.address) {
                self.$message.error(
                    "详细信息为必填项，请在地图的边界内点击选择详细信息"
                )
                return
            }
            if (
                this.formData.examine == "" ||
                this.formData.examine == null ||
                this.formData.examine == "null" ||
                this.formData.examine == undefined ||
                this.formData.examine == 0
            ) {
                this.$message.error("请选择审核状态")
                return
            }

            // if (this.formData.status == 2) {
            //     if (
            //         this.formData.reason == "" ||
            //         this.formData.reason == null ||
            //         this.formData.reason == "null" ||
            //         this.formData.reason == undefined
            //     ) {
            //         this.$message.error("审核不通过请输入审核意见")
            //         return
            //     }
            // }
            let data = {
                // id: this.formData.id,
                // status: this.formData.status,
                // reason: this.formData.reason,
                // provinceId: this.formData.provinceId,
                // cityId: this.formData.cityId,
                // quId: this.formData.quId,
                // streetId: this.formData.streetId
                ...this.formData,
            }
            if (this.formData.examine == 1) {
                data.approvalStatus = 0
            }
            this.$http
                .request({
                    url: "/ypt/admin/all/customer/info/updateExamine",
                    method: "POST",
                    data,
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.$message.success("审核成功")
                        this.getElderlyInformation()
                    } else {
                        this.$message.error("审核失败")
                    }
                    this.dialogVisible = false
                })
        },
        //搜索
        search() {
            this.getElderlyInformation()
        },
        //老人信息列表pagesize发生改变
        handletableDataSize(val) {
            this.pageSize = val
            this.getElderlyInformation()
        },
        //老人信息列表页码发生改变
        handleTableDataChange(val) {
            this.pageNo = val
            this.getElderlyInformation()
        },
        // 获取老人申请表格数据
        getElderlyInformation(s) {
            this.$http
                .request({
                    url: "/ypt/admin/all/customer/info/list",
                    method: "POST",
                    data: {
                        pageSize: this.pageSize,
                        pageNo: this.pageNo,
                        name: s === true ? "" : this.username,
                        phone: s === true ? "" : this.phone,
                        idCard: s === true ? "" : this.idCard,
                        menuType: "elderlyApply",
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content == null || res.content == "null") {
                            this.total = 0
                            this.tableData = []
                            return
                        }
                        this.total = res.content.count
                        const arr = res.content.list || []
                        arr.forEach((item) => {
                            item.streetId = item.streetId + ""
                        })
                        this.tableData = res.content.list
                    }
                })
        },
        // 保留条件刷新
        Reset1() {
            this.getElderlyInformation(true)
            this.tableChekbox = [
                "序号",
                "姓名",
                "性别",
                "联系方式",
                "身份证号",
                "年龄",
                "详细地址",
                "来源",
                "状态",
                "操作",
            ]
        },
        // 页面刷新
        Reset() {
            this.reload()
        },
        //table列checkbox发生变化
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        beforeAvatarUpload(file) {
            const isJPG =
                file.type === "image/jpeg" || file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG 格式!")
                return isJPG
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!")
                return isLt2M
            }
        },
        //自定义图片上传
        handleAvatarSuccess(res, file, name) {
            this.formData.photo = res.content
            this.formData.enclosure = res.content
        },
        //处理table表格表单
        async handleTableForm(title, row) {
            let self = this
            this.dialogVisibleTitle = title
            this.dialogVisible = true
            this.$http
                .request({
                    url: "/ypt/admin/all/customer/info/getById",
                    method: "POST",
                    data: {
                        id: row.id,
                    },
                })
                .then(async (res) => {
                    if (res.code === 200) {
                        this.formData = res.content
                        this.formData.elderlyBelongCategory = String(
                            this.formData.elderlyBelongCategory
                        )
                        this.formData.id = this.formData.id //来源
                        this.formData.examine = this.formData.examine //状态
                        this.formData.longitude = this.formData.longitude //经度
                        this.formData.latitude = this.formData.latitude //纬度
                        setTimeout(async () => {
                            await self.$nextTick(() => self.loadmap())
                        }, 30)
                        this.formData.provinceId = String(
                            this.formData.provinceId
                        )
                        console.log(
                            this.formData.provinceId,
                            typeof this.formData.provinceId
                        )
                        this.formData.cityId = String(this.formData.cityId)
                        this.formData.areaId = String(this.formData.areaId)
                        this.formData.areaId = this.formData.areaId.slice(0, 6)
                        this.formData.streetId = String(this.formData.streetId)

                        if (!this.formData.provinceId) return
                        let city = await self.getDistrict(
                            this.formData.provinceId
                        )
                        self.cityList = city.districtList
                        if (!this.formData.cityId) return
                        let area = await self.getDistrict(this.formData.cityId)
                        self.areaList = area.districtList
                        if (!this.formData.areaId) return
                        let streetList = await self.getStreetList(
                            this.formData.areaId
                        )
                        self.streetList = streetList
                        if (!this.formData.streetId) return
                        let communityList = await self.getCommityList(
                            this.formData.streetId
                        )
                        self.communityList = communityList
                        if (this.formData.communityId == null) {
                            this.formData.communityId == ""
                            self.communityList = []
                        } else {
                            //this.formData.communityId=Number(row.communityId)
                        }
                    }
                })
        },
        handleDelete(row) {
            let self = this
            self.$confirm("是否删除该条记录, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .request({
                            url: "/ypt/admin/all/customer/info/deleteById",
                            method: "POST",
                            data: {
                                id: row.id,
                            },
                        })
                        .then((res) => {
                            if (res.code === 200) {
                                this.getElderlyInformation()
                                this.$message.success("删除成功")
                            } else {
                                this.$message.error("删除失败")
                            }
                        })
                })
                .catch(() => {
                    self.$message({
                        type: "info",
                        message: "已取消删除",
                    })
                })
        },
        //加载地图
        loadmap() {
            return new Promise((resolve, reject) => {
                this.myMap = new AMap.Map("container", {
                    resizeEnable: true,
                    zoom: 18,
                })
                this.myMap.on("complete", () => {
                    resolve()
                })
            })
        },
        //table表格表单弹窗关闭时事件
        dialogVisibleClone() {
            this.formData.name = "" //姓名
            this.formData.gender = "" //性别
            this.formData.phone = "" //联系方式
            this.formData.idCard = "" //身份证号
            this.formData.age = "" //年龄
            this.formData.elderlyBelongCategory = "" //老人类型
            this.formData.provinceId = "" //省
            this.formData.cityId = "" //市
            this.formData.areaId = "" //区
            this.formData.streetId = "" //街道
            this.formData.communityId = "" //社区
            this.formData.address = "" //居住地址
            this.formData.photo = "" //图片
            this.imageUrl = ""
            this.formData.reason = "" //原因
            this.formData.source = "" //来源
            this.formData.id = "" //来源
            this.formData.examine = "" //状态
            this.formData.longitude = "" //经度
            this.formData.latitude = "" //纬度
        },
    },
}
</script>

<style lang="less" scoped>
.table_container {
    width: 100%;
}

/deep/ .dialog_content {
    .avatar_uploader {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;

        img {
            width: 100%;
            height: 178px;
            display: block;
        }
    }
}
</style>